<div class="page-list create-page">
    <div class="page-list-wrapper">
        <div class="mantis-theme row d-flex w-100">
            <div class="col-sm-12">
                <div class="card">
                    <!-- Chat Room Modal -->
                    <app-chat-room-modal
                        *ngIf="showChatRoomModal"
                        [chatRoom]="editingChatRoom"
                        [step1FormData]="step1FormData"
                        [userTagLists]="userTagLists"
                        [initialStep]="chatRoomModalInitialStep"
                        (close)="onCloseChatRoomModal()"
                        (next)="onNextStep($event)"
                        (created)="onChatRoomCreated($event)"
                        (updated)="onChatRoomUpdated($event)">
                    </app-chat-room-modal>
                    
                    <app-system-chat-room-modal
                        *ngIf="showSystemChatRoomModal"
                        [chatRoom]="editingSystemChatRoom"
                        (close)="onCloseSystemChatRoomModal()"
                        (updated)="onSystemChatRoomUpdated($event)">
                    </app-system-chat-room-modal>
                    
                    <div class="chat-wrapper">
                        <div class="offcanvas-lg offcanvas-start chat-offcanvas" tabindex="-1" id="offcanvas_ChatRoom_list">
                            <div class="offcanvas-body p-0">
                                <div id="chat-room_list" class="show collapse collapse-horizontal">
                                    <div class="chat-user_list">
                                        <div class="card-body px-4">
                                            <div class="d-flex align-items-center justify-content-between mb-3">
                                                <h5 class="mb-0 fw-bold">
                                                    Group chats
                                                </h5>
                                                
                                                <button class="btn btn-primary btn-sm btn-new-room" (click)="onNewRoomButtonClick()">
                                                    <img src="assets/messaging/ic_plus_small_white.svg" alt="" class="btn-new-room-icon">
                                                    New
                                                </button>
                                            </div>
                                            
                                            <div class="d-flex align-items-center gap-2 mb-3">
                                                <div class="form-search position-relative flex-grow-1">
                                                    <span class="search-icon">
                                                        <img src="assets/common/ic_search.svg" alt="Search">
                                                    </span>
                                                    
                                                    <input type="search" 
                                                        class="form-control" 
                                                        placeholder="Search group chats"
                                                        [(ngModel)]="searchQuery"
                                                        (ngModelChange)="searchQueryStream.next($event)" />

                                                    <button type="button"
                                                            class="clear-search"
                                                            *ngIf="searchQuery"
                                                            (click)="clearSearch()">
                                                        <img src="assets/common/ic_x.svg" alt="Clear search">
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="filter-buttons d-flex gap-2 mb-3">
                                                <button class="btn"
                                                        type="button"
                                                        [ngClass]="{ 'btn-filter-active': !roomStatus }"
                                                        (click)="setRoomStatus('')">
                                                    All
                                                </button>
                                                <button class="btn"
                                                        type="button"
                                                        [ngClass]="{ 'btn-filter-active': roomStatus === 'unread' }"
                                                        (click)="setRoomStatus('unread')">
                                                    Unread
                                                </button>
                                                <button class="btn"
                                                        type="button"
                                                        [ngClass]="{ 'btn-filter-active': roomStatus === 'archived' }"
                                                        (click)="setRoomStatus('archived')">
                                                    Archived
                                                </button>
                                                <button class="btn"
                                                        type="button"
                                                        [ngClass]="{ 'btn-filter-active': roomStatus === 'favorited' }"
                                                        (click)="setRoomStatus('favorited')">
                                                    Favorites
                                                </button>
                                            </div>
                                        </div>

                                        <div class="chat-thread-list-container">
                                            <div class="card-body py-0 px-0">
                                                <!-- System Chat Rooms -->
                                                <ng-container *ngTemplateOutlet="systemChatRoomList"></ng-container>
                                                
                                                <!-- Custom Group Chats Label -->
                                                <div class="custom-group-chats-label">
                                                    <h6 class="mb-0">Custom group chats</h6>
                                                </div>
                                                
                                                <!-- Custom Chat Rooms List -->
                                                <ng-container *ngTemplateOutlet="customChatRoomList"></ng-container>
                                            </div>
                                        </div>                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="chat-content">
                            <app-messages-tab
                                    [context]="'chatRoom'"
                                    [chatRoom]="selectedChatRoom"
                                    [resetTrigger]="resetMessagesTabTrigger"
                                    [refreshListOnFlagsChange]="roomStatus === 'favorited' || roomStatus === 'archived'"
                                    [isCoach]="isCoach"
                                    (messageSent)="onMessageSent($event)"
                                    (chatRoomUpdated)="onRoomUpdated($event)"
                                    (chatCreated)="onRoomCreated($event)"
                                    (createNewChatRoom)="onNewRoomButtonClick()"
                                    (editCustomChatRoom)="onEditCustomChatRoom($event)"
                                    (editSystemChatRoom)="onEditSystemChatRoom($event)"
                                    (addMembersToChatRoom)="onAddMembersToChatRoom($event)">
                            </app-messages-tab>
                        </div>
                        
                        @if (selectedChatRoom) {
                            <app-chat-room-details-sidebar
                                [chatRoom]="selectedChatRoom"
                                [isCoach]="isCoach"
                                (editCustomChatRoom)="onEditCustomChatRoom($event)"
                                (editSystemChatRoom)="onEditSystemChatRoom($event)"
                                (addMembersToChatRoom)="onAddMembersToChatRoom($event)">
                            </app-chat-room-details-sidebar>
                        }
                        
                        <div class="offcanvas-md offcanvas-end chat-offcanvas" tabindex="-1" id="offcanvas_ChatRoom_info">
                            <div class="offcanvas-header">
                                <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
                            </div>
                            
                            <div class="offcanvas-body p-0">
                                <!-- Placeholder for offcanvas chat room info -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #systemChatRoomList>
    @if (systemChatRooms && systemChatRooms.length > 0) {
        <div class="system-chat-room-divider"></div>

        @for (chatRoom of systemChatRooms; track chatRoom.id) {
            <a href="javascript:"
                class="list-group-item list-group-item-action user-list system-chat-room py-2"
                (click)="onSelectedChatRoom(chatRoom)"
                [ngClass]="{ 'bg-light-primary': chatRoom.id === selectedChatRoom?.id }">
                <div class="media align-items-center">
                    <div class="chat-avatar position-relative">
                        @if (chatRoom.image?.thumbnail_url) {
                            <img class="avatar-image" src="{{ chatRoom.image.thumbnail_url }}" alt="Chat room image" />
                        } @else {
                            <div class="group-chat-icon group-chat-icon-wrapper">
                                <img class="avatar-image" src="assets/messaging/ic_group_chat_placeholder.svg" alt="Group chat" />
                            </div>
                        }
                    </div>
                    
                    <div class="media-body">
                        <div class="d-flex align-items-center justify-content-between mb-1">
                            <h5 class="mb-0 text-truncate fw-bold">All clients</h5>
                            
                            @if (chatRoom.last_message) {
                                <span class="text-sm text-muted fw-bold flex-shrink-0 ml-2">
                                    @if (chatRoom.last_message.created_at.substring(0, 10) == today) {
                                        {{ chatRoom.last_message.created_at | dateFormat:'shortTime' }}
                                    } @else if (chatRoom.last_message.created_at.substring(0, 10) == yesterday) {
                                        Yesterday
                                    } @else {
                                        {{ chatRoom.last_message.created_at | dateFormat:'MM/dd/yy' }}
                                    }
                                </span>
                            }
                        </div>
                        
                        <div class="mb-1">
                            <span class="text-sm text-muted">
                                {{ chatRoom.member_count || 0 }} {{ chatRoom.member_count === 1 ? 'member' : 'members' }}. All app users included.
                            </span>
                        </div>
                        
                        <div class="d-flex align-items-center last-message-preview">
                            <span class="text-muted text-truncate d-inline-flex align-items-center gap-1">
                                @if (chatRoom.last_message.author?.name) {
                                    <span class="fw-bold">{{ chatRoom.last_message.author.name }}:</span>
                                    <span>{{ getLastMessage(chatRoom) }}</span>
                                } @else {
                                    <span>{{ getLastMessage(chatRoom) }}</span>
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </a>
        }
    }
</ng-template>

<ng-template #customChatRoomList>
    <div class="list-group list-group-flush">
        @if (customChatRooms && customChatRooms.length > 0) {
            @for (chatRoom of customChatRooms; track chatRoom.id) {
                <a href="javascript:"
                   class="list-group-item list-group-item-action user-list"
                   (click)="onSelectedChatRoom(chatRoom)"
                   [ngClass]="{ 'bg-light-primary': chatRoom.id === selectedChatRoom?.id }">
                    <div class="media align-items-center">
                        <div class="chat-avatar position-relative">
                            @if (chatRoom.image?.thumbnail_url) {
                                <img class="avatar-image" src="{{ chatRoom.image.thumbnail_url }}" alt="Chat room image" />
                            } @else {
                                <div class="avatar-circle">
                                    <span class="avatar-initials">{{ getRoomInitials(chatRoom) }}</span>
                                </div>
                            }
                        </div>
                        
                        <div class="media-body">
                            <div class="d-flex align-items-center justify-content-between mb-1">
                                <div class="d-flex align-items-center">
                                    @if (chatRoom.is_favorited || chatRoom.is_pinned) {
                                        <div class="thread-flags d-flex align-items-center">
                                            @if (chatRoom.is_favorited) {
                                                <img class="thread-flag-icon me-1" src="assets/messaging/ic_favorited.svg" alt="Favorited">
                                            }
                                            @if (chatRoom.is_pinned) {
                                                <img class="thread-flag-icon me-1" src="assets/messaging/ic_pinned.svg" alt="Pinned">
                                            }
                                        </div>
                                    }
                                    <h5 class="mb-0 text-truncate fw-bold">{{ chatRoom.name }}</h5>
                                </div>
                                
                                @if (chatRoom.last_message) {
                                    <span class="text-sm text-muted f-w-400">
                                        @if (chatRoom.last_message.created_at.substring(0, 10) == today) {
                                            {{ chatRoom.last_message.created_at | dateFormat:'shortTime' }}
                                        } @else if (chatRoom.last_message.created_at.substring(0, 10) == yesterday) {
                                            Yesterday
                                        } @else {
                                            {{ chatRoom.last_message.created_at | dateFormat:'MM/dd/yy' }}
                                        }
                                    </span>
                                }
                            </div>

                            <div class="mb-1">
                                <span class="text-sm text-muted">
                                    {{ chatRoom.member_count || 0 }} {{ chatRoom.member_count === 1 ? 'member' : 'members' }}
                                </span>
                            </div>
                            
                            <div class="d-flex align-items-center justify-content-between">
                                @if (chatRoom.last_message) {
                                    <div class="d-flex align-items-center last-message-preview">
                                        <span class="text-muted text-truncate d-inline-flex align-items-center gap-1">
                                            @if (chatRoom.last_message.author?.name) {
                                                <span class="fw-bold">{{ chatRoom.last_message.author.name }}:</span>
                                                <span>{{ getLastMessage(chatRoom) }}</span>
                                            } @else {
                                                <span>{{ getLastMessage(chatRoom) }}</span>
                                            }
                                        </span>
                                    </div>
                                } @else {
                                    <div class="d-flex align-items-center">
                                        <span class="text-muted text-truncate">
                                            No messages yet
                                        </span>
                                    </div>
                                }
                                
                                <span class="flex-shrink-0">
                                    @if (chatRoom.unread_count > 0) {
                                        <span class="badge bg-primary rounded-pill unread-badge">
                                            {{ chatRoom.unread_count }}
                                        </span>
                                    } @else {
                                        <i class="text-primary f-12" antIcon type="check" theme="outline"></i>
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            }
            
            @if (showLoadMoreRooms) {
                <div class="text-center py-3">
                    <button class="btn btn-sm btn-outline-primary" 
                            type="button"
                            (click)="loadMoreChatRooms()">
                        Load more group chats
                    </button>
                </div>
            }
        } @else if (!isLoading) {
            @if (roomStatus === '' && searchQuery === '') {
                <div class="text-center no-conversations">
                    <img src="../../assets/messaging/ic_no_conversations.svg" />
                    <h6>No group chats</h6>
                    <span>You haven't created any group chats yet. Create a custom group chat to communicate with multiple users in one place.</span>
                </div>
            } @else {
                <div class="text-center no-conversations">
                    <img src="../../assets/messaging/ic_no_conversations.svg" />
                    <h6>No group chats found</h6>
                    <span>We couldn't find any group chats. Please try searching with a different term.</span>
                </div>
            }
        }
    </div>
</ng-template>

